import Card from '@/components/Card/Card.vue';
import FetchData from '@/components/DataProvider/FetchData.vue';
import IconSpinner from '@/components/Icon/icons/IconSpinner.vue';
import Pagination from '@/components/Pagination/Pagination.vue';
import { computed, defineComponent, onMounted, ref, } from '@vue/composition-api';
import { useClient, useMobileView } from '@/composables';
import { useRouteQuery } from '@/composables';
import { mapQueryToApiV2 } from '@/util/query';
import { FILTER_DEBOUNCE } from '@/constants/filters';
import { DEFAULT_CARD_LIMIT } from '@/constants/pagination';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
const { useGetters } = createNamespacedHelpers('user');
export default defineComponent({
    name: 'ClientBrands',
    components: {
        Card,
        FetchData,
        IconSpinner,
        Pagination,
    },
    props: {
        additionalQuery: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props, ctx) {
        const { client } = useClient();
        const { routeQuery, changePage, selectLimit } = useRouteQuery(ctx);
        const { hasAdminRights } = useGetters(['hasAdminRights']);
        const { isMobileView } = useMobileView();
        const sidebarOpen = ref(false);
        const listUpdatesCounter = ref(0);
        const brandsList = ref([]);
        const lastPage = ref(1);
        const computedQuery = computed(() => {
            const { q, ...query } = mapQueryToApiV2(routeQuery.value);
            return {
                ...query,
                name: q,
                clientId: client.value.id,
                ...props.additionalQuery,
            };
        });
        const currentPage = computed(() => {
            return computedQuery.value?.page ?? 1;
        });
        const updateBrandsList = (data) => {
            brandsList.value = data.nodes || [];
            lastPage.value = Math.ceil(data.totalCount / (computedQuery.value?.perPage || DEFAULT_CARD_LIMIT));
        };
        onMounted(() => {
            selectLimit(DEFAULT_CARD_LIMIT);
        });
        return {
            FILTER_DEBOUNCE,
            client,
            listUpdatesCounter,
            hasAdminRights,
            sidebarOpen,
            computedQuery,
            changePage,
            brandsList,
            lastPage,
            currentPage,
            updateBrandsList,
            isMobileView,
        };
    },
});
